module.exports = "<my-app-sidenav></my-app-sidenav>\n\n<section id=\"page-container\" class=\"app-page-container\">\n    <my-app-header></my-app-header>\n\n    <div class=\"app-content-wrapper\">\n        <div class=\"app-content\">\n            <div class=\"full-height\">\n                <router-outlet></router-outlet>\n            </div>\n        </div>\n\n        <my-app-footer></my-app-footer>\n    </div>\n</section>\n\n<my-app-search-overlay></my-app-search-overlay>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/layout.component.html
// module id = 1268
// module chunks = 10